export default __webpack_public_path__ + "files/be592857057e09fc1ca17c0e45c11f50.png";